export interface AdminSettingsStepProps {
  teamName: string;
  members: string[];
}

export const adminSettingsDefaultProps = {
  teamName: 'Your team name',
  members: [],
};
